import React from 'react';
import Modal from 'react-awesome-modal';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from '../../../store/actions';

class DialogDeleteItemInCart extends React.Component {
    render() {
        const {
            updateCartAvailiableSelected,
            dialogDelete,
            CloseDialogDeleteItemInCart,
            deleteData,
            DeleteItemInCart,
            wording,
            ClearBuyNow,
            itemSelected
        } = this.props;

        return (
            <Modal
                visible={dialogDelete}
                width='450'
                effect='fadeInUp'
                onClickAway={CloseDialogDeleteItemInCart}>
                <div style={{ margin: 20 }}>
                    <div className='dialog-header'>
                        <h4 style={{ color: '#ef5659' }}>
                            {wording.cartPage.dialogDeleteItemInCart.title}
                        </h4>
                    </div>
                    <div className='dialog-body mt-20 mb-20'>
                        <p style={{ fontSize: 16 }}>
                            {deleteData && deleteData.itemName}
                        </p>
                    </div>
                    <div className='dialog-action row'>
                        <div className='col-md-6'>
                            <button
                                style={{ width: '100%' }}
                                className='btn btn-md btn-dark'
                                onClick={async () => {
                                    if (deleteData.type === "buyNow") {
                                        await ClearBuyNow(deleteData);
                                    } else await DeleteItemInCart(deleteData, itemSelected);
                                    await updateCartAvailiableSelected(
                                        deleteData
                                    );
                                }}>
                                {wording.cartPage.dialogDeleteItemInCart.ok}
                            </button>
                        </div>
                        <div className='col-md-6'>
                            <button
                                style={{ width: '100%' }}
                                className='btn btn-md btn-light-red'
                                onClick={CloseDialogDeleteItemInCart}>
                                {wording.cartPage.dialogDeleteItemInCart.cancle}
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

const mapStateToProps = ({ cart, language }) => ({
    dialogDelete: cart.dialogDelete,
    deleteData: cart.deleteData,
    wording: language.wording
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            DeleteItemInCart: Actions.DeleteItemInCart,
            CloseDialogDeleteItemInCart: Actions.CloseDialogDeleteItemInCart,
            ClearBuyNow: Actions.ClearBuyNow
        },
        dispatch
    );
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DialogDeleteItemInCart);
